export default "__VITE_ASSET__AeyNAHTm__"